const items = {
  "nut.users.sign-in.title": "登录",
  "nut.users.sign-up.title": "注册",
  "nut.users.sign-in-up.title": "登录/注册",
  "nut.users.logs.title": "日志列表",
  "nut.users.forgot-password.title": "忘记密码",
};

export default items;
